
























































































































































import { Component, Vue } from 'vue-property-decorator';
import { Ax } from '@/utils';
import I18n from '../I18n';
import {createCodeNameOption, salaryForms, staffTabAccess, store} from '../common';
import { CodeNameSelect, ListItem, ListItemPart, Overlay } from '../components';
import { SingleOrgField } from '../organizations';
import { Comp, Dict, Org, Report, Utils, Version } from '../types';
import { SingleVersionField } from '../versions';
import Ead from './Ead.vue';
import ConfirmModal from "@/modules/budget/staffing-table/components/ConfirmModal.vue";


const i18n = new I18n('modules.budget.staffing_table.config');


@Component({
    components: {
        CodeNameSelect,
        ConfirmModal,
        'ead': Ead,
        ListItem,
        ListItemPart,
        Overlay,
        SingleOrgField,
        SingleVersionField,
    }
})
export default class Page extends Vue {
    // region Lifecycle
    // noinspection JSUnusedLocalSymbols
    private created(): void {
        this.$watch('org', (org: Org | null) => {
            store.org = org;
            store.conditionExp = null
            this.version = null;
        });
        this.$watch('version', (version: Version | null) => {
            store.version = version;
            store.gaDepartmentList = []
            store.subDepartments = []
            this.selectedBudgetProgram = null;
            this.tryReloadSettings(() => {
                this.tryReloadBudgetPrograms();
            });
        });
        this.$watch('selectedBudgetProgramCode', (newValue: number | null) => {
            if (this.settingsBudgetProgram !== newValue) {
                this.settingsBudgetProgram = newValue;
            }
        });
        this.$watch('selectedEduOrgType', (selectedEduOrgType: Dict.StEduOrgType | null) => {
            this.settingsEduOrgTypeCode = (selectedEduOrgType?.code ?? null);
        });
    }

    // noinspection JSUnusedLocalSymbols
    private mounted() {
        this.reset();
    }
    // endregion


    // region Утилиты
    private i18n = i18n;

    // Доступ к редактированию данных
    get isEditable(): boolean {
        return staffTabAccess.isEditable;
    }

    private toast(type: 'danger' | 'warning' | 'success', title: string, message: string) {
        this.$bvToast.toast(message, {
            title: title,
            variant: type,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }
    // endregion

    private get isEducationAbp(): boolean {
        return (this.abpCode === '261') || (this.abpCode === '360');
    }

    // region Организация
    private org: Org | null = store.org;

    private get gu(): Dict.Gu | null {
        if (this.org?.type === 'GU' || this.org?.type === 'KGKP') {
            return this.org.gu;
        } else {
            return null;
        }
    }

    private get guCode(): string | null {
        const org = this.org;
        if (org === null) {
            return null;
        }

        if (org.type === 'GU') {
            return org.gu.code;
        } else if (org.type === 'KGKP') {
            const kgkp = org.kgkp;
            return (kgkp.codeGu || kgkp.codeGuOwner || null);
        } else {
            return null;
        }
    }

    private get abpCode(): string | null {
        const guCode = this.guCode;
        if ((guCode === null) || (guCode.length < 3)) return null;
        return guCode.substring(0, 3);
    }
    // endregion


    // region Версия ШР
    private version: Version | null = store.version;
    // endregion


    // region Формы расчетов
    private get formOptions(): Array<Comp.DropdownItemDef<Report.FormKey | null>> {
        const result: Array<Comp.DropdownItemDef<Report.FormKey | null>> = salaryForms.map(form => {
            const name = this.i18n.enumTranslate('report_form_key_name', form);
            return createCodeNameOption<Report.FormKey | null>(form, this.i18n.enumTranslate('report_form_key', form), name);
        });
        result.unshift({
            text: '',
            value: null,
        });

        return result;
    }
    // endregion

    // confirmModal

    private initialOrgCode: string | null = null
    private showConfirmModal: boolean = false
    private closeConfirmModal() {
        this.showConfirmModal = false
    }



    // region Бюджетные программы
    private budgetProgramsLoading = false;

    private budgetPrograms: Array<Dict.EbkFunc> = [];

    private get budgetProgramOptions(): Array<Comp.DropdownItemDef<Dict.EbkFunc | null>> {
        const result: Array<Comp.DropdownItemDef<Dict.EbkFunc | null>> = [];
        result.push({
            text: '',
            value: null,
        });

        const isKazakh = this.i18n.isKazakh;
        this.budgetPrograms.forEach(budgetProgram => {
            const title = (isKazakh ? budgetProgram.nameKk : budgetProgram.nameRu) ?? '';

            const code = String(budgetProgram.prg).padStart(3, '0');

            result.push(createCodeNameOption<Dict.EbkFunc | null>(budgetProgram, code, title));
        });

        return result;
    }

    private selectedBudgetProgram: Dict.EbkFunc | null = null;

    private get selectedBudgetProgramCode(): number | null {
        const selectedBudgetProgram = this.selectedBudgetProgram;
        if (selectedBudgetProgram === null) return null;
        return selectedBudgetProgram.prg;
    }


    private tryReloadBudgetPrograms() {
        if (this.abpCode === null) return;
        this.reloadBudgetPrograms();
    }

    private reloadBudgetPrograms() {
        if (this.budgetProgramsLoading) {
            console.error('Cannot reload budget programs - another loading is running');
            return;
        }

        const abpCode = this.abpCode;
        if (abpCode === null) {
            console.error('Cannot reload budget programs - ABP code is null');
            return;
        }

        this.budgetPrograms = [];
        this.budgetProgramsLoading = true;
        Ax<Array<Dict.EbkFunc>>(
            { url: `/api/budget/staffing_table/report/budget-programs?abp-code=${abpCode}&date=${Date.now()}` },
            data => {
                const selectedBudgetProgram = data
                    .find(budgetProgram => (budgetProgram.prg === this.settingsBudgetProgram))
                    ?? null;
                this.budgetPrograms = data;
                this.selectedBudgetProgram = selectedBudgetProgram;
            },
            error => this.toast('danger', this.i18n.translate('error.cannot_load_budget_programs'), error.toString()),
            () => { this.budgetProgramsLoading = false; }
        );
    }
    // endregion


    // region Организации образования - типы организаций
    private eduOrgTypes: Array<Dict.StEduOrgType> = [];
    private eduOrgTypesLoading = false;
    private selectedEduOrgType: Dict.StEduOrgType | null = null;
    private eduOrgTypeChangeFlag: number = Number.MIN_SAFE_INTEGER;

    private get eduOrgTypeOptions(): Array<Comp.DropdownItemDef<Dict.StEduOrgType | null>> {
        const result: Array<Comp.DropdownItemDef<Dict.StEduOrgType | null>> = [];

        const locale = this.i18n.locale.trim().toLowerCase();
        this.eduOrgTypes.forEach((eduOrgType) => {
            const code = eduOrgType.code;

            let name: string;
            switch (locale) {
                case 'en':
                    name = eduOrgType.nameEn;
                    break;
                case 'kk':
                    name = eduOrgType.nameKk;
                    break;
                default:
                    name = eduOrgType.nameRu;
                    break;
            }

            result.push({
                text: `${code} - ${name}`,
                value: eduOrgType,
            });
        });

        return result;
    }

    private reloadEduOrgTypes() {
        if (this.eduOrgTypesLoading) {
            console.error('Cannot reload EDU org types - another loading is running');
            return;
        }

        this.eduOrgTypesLoading = true;

        // /api/budget/staffing_table/edu-orgtype
        // items-per-page
        Ax<Utils.PaginationList<Dict.StEduOrgType>>(
            { url: `/api/budget/staffing_table/edu-orgtype?items-per-page=10000` },
            (data) => {
                this.eduOrgTypes = data.items;
                this.updateSelectedEduOrgType();
            },
            (error) => {
                this.toast('danger', this.i18n.translate('error.cannot_load_edu_org_types'), error.toString());
            },
            () => {
                this.eduOrgTypesLoading = false;
            },
        );
    }

    private updateSelectedEduOrgType() {
        let selectedEduOrgType: Dict.StEduOrgType | null = null;
        if (this.settingsEduOrgTypeCode !== null) {
            const index = this.eduOrgTypes.findIndex((eduOrgType) => (eduOrgType.code === this.settingsEduOrgTypeCode));
            if (index >= 0) {
                selectedEduOrgType = this.eduOrgTypes[index];
            }
        }

        if (this.selectedEduOrgType?.id !== selectedEduOrgType?.id) {
            this.initialOrgCode = selectedEduOrgType?.code ?? null
            this.selectedEduOrgType = selectedEduOrgType;
        }
    }
    // endregion


    // region Настройки
    private settingsReportForm: Report.FormKey | null = null;
    private settingsBudgetProgram: number | null = null;
    private settingsEduOrgTypeCode: string | null = null;
    private loadingSettings = false;

    private reloadSettings(next?: (() => void)) {
        if (this.loadingSettings) {
            console.error('Cannot reload settings - another loading is running');
            return;
        }

        const version = this.version;
        if (version === null) {
            console.error('Cannot reload settings - version is null');
            return;
        }

        this.loadingSettings = true;
        Ax<Org.Settings>(
            { url: `/api/budget/staffing_table/gu-settings/${version.id}` },
            data => {
                this.settingsReportForm = data.form;
                this.settingsBudgetProgram = data.budgetProgram;
                this.settingsEduOrgTypeCode = data.orgType;
                this.updateSelectedEduOrgType();
            },
            error => this.toast('danger', this.i18n.translate('error.cannot_load_settings'), error.toString()),
            () => {
                this.loadingSettings = false;
                if (next) setTimeout(next);
            }
        );
    }

    private tryReloadSettings(next?: (() => void)) {
        if (this.version === null) return;
        this.reloadSettings(next);
    }

    private confirmSaveSettings() {
        const isChanged = (this.initialOrgCode !== this.settingsEduOrgTypeCode)
        if (this.isEducationAbp && isChanged) {
            this.showConfirmModal = true;
        } else {
            this.saveSettings()
        }
    }

    private saveSettings() {
        if (this.loadingSettings) {
            console.error('Cannot save settings - another loading is running');
            return;
        }

        const version = this.version;
        if (version === null) {
            console.error('Cannot save settings - version is null');
            return;
        }

        const versionId = version.id;
        if (versionId === null) {
            console.error('Cannot save settings - version ID is null');
            return;
        }

        const data: Org.Settings = {
            form: this.settingsReportForm,
            budgetProgram: this.settingsBudgetProgram,
            orgType: this.settingsEduOrgTypeCode,
        }

        this.showConfirmModal = false
        this.loadingSettings = true;

        Ax(
            {
                url: `/api/budget/staffing_table/gu-settings/${versionId}`,
                method: 'POST',
                data,
            },
            () => {
                this.toast('success', this.i18n.translate('settings'), this.i18n.commonTranslate('saved'));

                const orgTypeChanged = (this.initialOrgCode != this.settingsEduOrgTypeCode);

                this.initialOrgCode = this.settingsEduOrgTypeCode;

                if (orgTypeChanged) {
                    if (this.eduOrgTypeChangeFlag >= Number.MAX_SAFE_INTEGER) {
                        this.eduOrgTypeChangeFlag = Number.MIN_SAFE_INTEGER;
                    } else {
                        this.eduOrgTypeChangeFlag++;
                    }
                }
            },
            error => this.toast('danger', this.i18n.translate('error.cannot_load_settings'), error.toString()),
            () => { this.loadingSettings = false; }
        );
    }

    private reset() {
        this.tryReloadSettings(() => {
            this.tryReloadBudgetPrograms();
            this.reloadEduOrgTypes();
        });
    }
    // endregion
}
